export default __webpack_public_path__ + "static/media/Screenshot_A14.9b4a92ee.jpg";